// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"3fb3d315","629":"34d4d55a"}[chunkId] + ".chunk.js";
};